import React, {useState} from 'react';
import { Link as LinkScroll} from 'react-scroll';
import { Link as LinkPage, useLocation} from 'react-router-dom'
// import { Link as LinkPage} from 'react-router-dom'
import './footer2.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import { faSquareXTwitter } from '@fortawesome/free-brands-svg-icons'


import logo from "../../assets/images/logo2/ponos-logo-mark-blue-original.svg";


const Footer2 = () => {

  const location = useLocation(); // Get current route

  const linkedin = <FontAwesomeIcon
   className='fontAweosmeX' 
   icon={faLinkedin} 
   style={{color: "#000000",fontSize: '22px', 
  transition: 'color 0.3s ease-in', }} />
     const linkedinHover = <FontAwesomeIcon 
     className='fontAweosmeX' 
     icon={faLinkedin} 
     style={{color: "#0F62FE",fontSize: '22px',
    transition: 'color 0.3s ease-in, transform 0.3s ease-in', }} />

     const xTwitter = <FontAwesomeIcon className='fontAweosmeX' icon={faSquareXTwitter} 
     style={{color: "#000000",fontSize: '22px',
    transition: 'color 0.3s ease-in', }} />
     const xTwitterHover = <FontAwesomeIcon className='fontAweosmeX' icon={faSquareXTwitter} 
     style={{color: "#0F62FE",fontSize: '22px',
    transition: 'color 0.3s ease-in, transform 0.3s ease-in', }} />

     const keys = [1,2]
   const imageKey = keys.map(key=>{
    return key
   })
   

   const [isHover, setIsHover] = useState(-1);

    const renderLogoLink = () => {
             
              if (location.pathname === '/') {
                return (
                 
                  <LinkScroll 
                  className='footer2-logo-wrapper' 
                   to="homeNavApp" // Scroll to <div id="home"> on Home page
                    smooth={true}
                    offset={0}
                   duration={500}
                  >
                  <img className="footer2-logo-img" src={logo} alt="ponos-logo-mark" />
                 </LinkScroll>

                );
              }
              return (
              
                 <LinkPage 
                  className='footer2-logo-wrapper' 
                   to={{ pathname: '/', state: { scrollTo: 'homeNavApp' } }}
                   onClick={() => {
                   
                     localStorage.setItem('scrollTo', 'homeNavApp'); // Fallback
                   }}
                  >
                  <img className="footer2-logo-img" src={logo} alt="ponos-logo-mark" />
                 </LinkPage>
              );
            };

    const renderFooterLink = (path, section, linkText) => {
    if (location.pathname === path) {
      return (
       
         <LinkScroll 
         className='footer_brand_link'
          to={section}
          smooth={true}
          offset={0}
          duration={500}
         >
             <p>{linkText}</p> 
          </LinkScroll>
      );
    }
    return (
    
       <LinkPage 
         className='footer_brand_link'
         to={{ pathname: path, state: { scrollTo: section } }}
         onClick={() => {
          localStorage.setItem('scrollTo', section);
          }}
         >
             <p>{linkText}</p> 
          </LinkPage>
    );
  };


  return (
    <section id="contact" className='section_footer'>
        <div className="container footer2-main">
               <div className='footer2 footer2_section__padding'>
        <div className='footer2-heading'>
         
            <h1>Get In Touch</h1>
            
             <p>Got a project or idea? Drop us a line — let’s build together. We’ll get back to you fast.</p>
        </div>
       
         <a href="mailto:info@ponos.technology" className='footer2-btn-new no-wrap'>
                          <span>Contact us</span>
                         </a>
                       
        <div className='footer2-links'>
          <div className='footer2-links_logo'>
           
              {/* <p className='footer2-logo-wrapper'>
                    <img className="footer2-logo-img" src={logo} alt="ponos-logo-mark" />
                </p> */}


                 {/* <LinkScroll className='footer2-logo-wrapper' to="home">
                  <img className="footer2-logo-img" src={logo} alt="ponos-logo-mark" />
             </LinkScroll> */}

              {renderLogoLink()}

                  <p className='footer2-paragraf'>Building the Efficient<br/>and <span className='nowrap'>Post-Quantum</span> Secure<br/>Digital Infrastructures</p>

                
          </div>

          <div className='footer2_links-two-right'>

              <div className='footer2-links_div1'>
            <h4>Follow us:</h4>
              <p className='p-l-social'>
              <a
              onMouseEnter={()=>setIsHover(imageKey[1])}
              onMouseLeave={()=>setIsHover(-1)}
              href="https://www.linkedin.com/company/ponostechnology/" target="_blank" rel="noopener noreferrer">
              { isHover === imageKey[1]
                    
                    ? linkedinHover
                    : linkedin

                   }
              </a>
              </p> 

               
               <p className='p-l-social'>
                <a
               onMouseEnter={()=>setIsHover(imageKey[2])}
              onMouseLeave={()=>setIsHover(-1)}
              href="https://twitter.com/PonosTechnology" target="_blank" rel="noopener noreferrer">
              { isHover === imageKey[2]

                    ? xTwitterHover
                    : xTwitter

                   }
              </a>
              </p> 
             {/* <div className='footer2-social'>
                   
             </div> */}
            
             
          </div> 


             <div className='footer2-links_div2'>
            <h4>Contact</h4>
              <p>Email: info@ponos.technology</p>
               <p>Ponos Technology AG</p>
               <p>Gotthardstrasse 26. Zug, Switzerland</p> 
               
               {/* <LinkPage to={'/brand-assets'} rel="noopener noreferrer" className='footer_brand_link'>
               <p>Brand Assets</p> 
              </LinkPage> */}
              {renderFooterLink('/brand-assets', 'brand-assetsNavApp', 'Brand Assets')}

          </div>

          </div>

        </div>
         
        <div className='footer2-copyright'>
          <hr />
        <p>Copyright © 2023–2026 Ponos Technology</p> 
          
        </div>
    </div>
            </div>
       </section>

  )
}

export default Footer2
